module.exports = __webpack_public_path__ + "img/16agefiph.4fd7225c.png";